import httpApi from '../api/httpApi';
import useSWR from 'swr';
import {
    AdminUsersParams,
    AdminUsersResp,
} from '../../models/Admin/AdminUsers';

const USER_URL = '/api/v1/admin/users';

const useAdminUserSWR = (params: AdminUsersParams) => {
    const fetchUser = (query, params): Promise<AdminUsersResp> => {
        return httpApi
            .get<AdminUsersResp>(query, params)
            .then((res) => {
                return res.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        [USER_URL, params],
        ([url, params]) => fetchUser(url, params),
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        users: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useAdminUserSWR;
